import LangSwitch from "./LangSwitch";
export default LangSwitch;
